import { ShieldCheck, Leaf, Heart } from "lucide-react";
import { IMAGES } from "../data";
import { Breadcrumb } from "../Layout";

export default function APropos() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-14 sm:px-8">
      <Breadcrumb items={[{ label: "Accueil", to: "/" }, { label: "À propos" }]} />
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <p className="tag-mono mb-4 text-[#E4C5B3]">À propos</p>
          <h1 className="font-display text-4xl font-medium leading-[1.1] tracking-tight sm:text-5xl">
            Une boutique en ligne dédiée aux prothésistes ongulaires
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 sm:text-lg">
            AB Nails est une boutique en ligne française spécialisée dans les produits professionnels pour
            ongles : gels de construction, vernis semi-permanents, fraises et embouts de ponceuse, et
            accessoires de nail art.
          </p>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-zinc-400">
            Notre sélection s'adresse aux professionnelles de la prothésie ongulaire qui recherchent des
            références fiables, avec un vrai conseil d'application derrière chaque produit.
          </p>
        </div>
        <div className="lg:col-span-5">
          <figure className="frame-editorial">
            <img
              src={IMAGES.nude.src}
              width={IMAGES.nude.width}
              height={IMAGES.nude.height}
              alt={IMAGES.nude.alt}
              loading="lazy"
              className="h-full w-full object-cover"
            />
          </figure>
        </div>
      </div>

      <section aria-labelledby="marque" className="mt-16 border-t border-white/10 pt-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="tag-mono mb-3 text-[#E4C5B3]">La marque</p>
            <h2 id="marque" className="font-display text-3xl font-medium tracking-tight sm:text-4xl">
              American Creator
            </h2>
            <p className="mt-5 text-base leading-relaxed text-zinc-400">
              Créée aux États-Unis en 2014, American Creator développe des produits professionnels pour
              l'ongle — dont le Framework Gel, son gel de construction emblématique décliné en teintes nude.
              AB Nails propose une sélection de ses références en France.
            </p>
          </div>
          <div className="grid gap-5 sm:grid-cols-3 lg:col-span-7">
            {[
              { icon: ShieldCheck, title: "Hypoallergénique", text: "Des formules présentées comme hypoallergéniques par la marque, testées en laboratoire indépendant." },
              { icon: Heart, title: "Cruelty-free", text: "Aucun test sur les animaux, un engagement affiché par American Creator depuis sa création." },
              { icon: Leaf, title: "Vegan", text: "Des formules vegan, pensées pour une pratique professionnelle exigeante et responsable." },
            ].map((f) => (
              <div key={f.title} className="border border-white/10 bg-[#15151C] p-6">
                <f.icon size={22} className="text-[#D4AF37]" aria-hidden="true" />
                <h3 className="mt-4 font-display text-lg font-medium">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-400">{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section aria-labelledby="approche" className="mt-16 grid grid-cols-1 gap-10 lg:grid-cols-12">
        <figure className="frame-editorial lg:col-span-5">
          <img
            src={IMAGES.texture.src}
            width={IMAGES.texture.width}
            height={IMAGES.texture.height}
            alt={IMAGES.texture.alt}
            loading="lazy"
            className="h-full w-full object-cover"
          />
        </figure>
        <div className="lg:col-span-7">
          <p className="tag-mono mb-3 text-[#E4C5B3]">Notre approche</p>
          <h2 id="approche" className="font-display text-3xl font-medium tracking-tight sm:text-4xl">
            Peu de références, mais les bonnes
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-zinc-400">
            Plutôt qu'un catalogue interminable, nous concentrons notre offre sur des gammes resserrées et
            cohérentes : des gels de construction teintés, des bases adaptées, des embouts de qualité
            professionnelle et des décors nail art choisis.
          </p>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-zinc-400">
            Et parce qu'un bon produit ne suffit pas, nous documentons les protocoles d'application —
            préparation, catalysation, finition — pour que chaque référence donne le meilleur d'elle-même
            entre vos mains.
          </p>
        </div>
      </section>
    </div>
  );
}
